import { createContext, useContext } from "react";

// Nombre, color y logo de la empresa (Configuraciones > Empresa). Lo llena App.js al
// cargar; `recargar` lo vuelve a pedir después de guardar cambios.
export const MarcaContext = createContext({ marca: null, recargar: () => {} });

export const useMarca = () => useContext(MarcaContext);
